import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'


function NavBar({toggle , setToggle}) {

    const {user} = useSelector(state => state.auth)
  return (
  <>
  {user?.isAdmin && ( <>   <nav style={{clipPath: toggle && "polygon(0 0, 100% 0, 100% 100%, 0 100%)"}}className="nabbar">
    <ul className="nav-links">
        
        { /* <Link to="/" onClick={()=> setToggle(false)} className="nav-link">
            <i className="bi bi-house"></i>
            Home
        </Link>   */ }
        <Link to="/attendance" onClick={()=> setToggle(false)} className="nav-link">
            <i className="bi bi-calendar-week"></i>
            Attendance
        </Link>
        <Link to="/admin-dashboard" onClick={()=> setToggle(false)} className="nav-link">
            <i className="bi bi-person-check"></i>
            Admin Dahshboard
        </Link>
    </ul>
</nav></>)}

  </>
  )
}

export default NavBar

